module.exports = __webpack_public_path__ + "3356c5036da14c78755b8d917c43f4fa.svg";